<template>
  <div
    :class="[
      'grid-editor-wrapper',
      {'is-edit': isEdit, 'is-loading': isLoading, 'is-last': !row.status_.isFirst && row.status_.isLast},
      col.editor.type
    ]"
    v-loading="isLoading"
    @click="showEditor"
    v-clickoutside="() => {if (isEdit && ['string','number'].includes(col.editor.type)) handleCancel()}">
    <component
      v-if="isEdit"
      :is="editorComponent"
      :options="col.editor"
      :data="row"
      :isEdit="isEdit"
      @submit="handlerSubmit"
      @cancel="handleCancel"
      ref="editor"/>
    <div
      v-if="isEdit && ['string', 'number'].includes(col.editor.type)"
      class="grid-editor-footer">
      <button
        type="button"
        class="btn btn-no-border btn-size-s btn-font-normal"
        @click.stop="handleCancel"
        v-html="L10n('cancel')"/>
      <button
        type="button"
        class="btn btn-no-border btn-size-s btn-font-normal"
        @click.stop="handlerSubmit"
        v-html="L10n('submit')"/>
    </div>
  </div>
</template>

<script>
import clickoutside from 'element-ui/lib/utils/clickoutside'

export default {
  name: 'GridEditor',
  directives: { clickoutside },
  props: {
    row: { type: Object, required: true },
    col: { type: Object, required: true }
  },
  data () {
    return {
      isEdit: false,
      isLoading: false,
      editorComponent: null
    }
  },
  created () {
    // TODO: validate filter type
    let type = ''
    switch (this.col.editor.type) {
      case 'checkbox':
        type = 'checkbox'
        break
      case 'date':
        type = 'date'
        break
      case 'select':
        type = 'select'
        break
      case 'number':
        type = 'number'
        break
      case 'string':
        type = 'string'
        break
    }
    if (type) {
      this.editorComponent = () => import(/* webpackChunkName: 'Grid' */ `@/components/Grid/Editors/${type}/index.vue`)
    } else {
      this.handle({ type: 'error' })
    }
  },
  watch: {
    isEdit (Value) {
      this.$emit('isEdit', Value)
    }
  },
  methods: {
    handleCancel () {
      this.isEdit = false
    },
    handlerSubmit () {
      this.$refs.editor
        .validate()
        .then(data => {
          if (this.row[this.col.editor.field] !== data[this.col.editor.field]) {
            this.isLoading = true
            this.isEdit = false
            this.$emit('change', this.col.editor, data, () => {
              this.isLoading = false
            })
          } else {
            this.isEdit = false
          }
        })
    },
    // PUBLIC
    showEditor () {
      if (!this.isEdit) {
        this.isEdit = true
      }
    }
  }
}
</script>

<style lang="stylus">
  .grid-editor-wrapper {
    position absolute
    top 0
    left -1px
    right -1px
    bottom -1px
    cursor pointer
    display flex
    flex-direction row
    align-items center
    box-sizing border-box
    padding 0 calc(.8rem - 1px)
    border-left 1px solid transparent
    border-right 1px solid transparent
    border-bottom 1px solid transparent
    &.checkbox {
      min-width 100% !important
    }
    &.is-loading {
      pointer-events none
    }
    .grid-editor {
      margin -2px 0 0
      position relative
      z-index 3
      width 100%
      .el-form-item {
        margin 0
      }
      .el-form-item__error {
        position absolute
        left 0
        width 100%
        text-align left
        &:before,
        &:after {
          border-bottom none
          border-top 5px solid #f56c6c
          top 100%
          right auto
          left 1rem
          bottom auto
        }
        &:before {
          border-bottom-color #888
          left calc(1rem + 1px)
        }
      }
    }

    /*padding */
    .grid-editor-footer {
      text-align center
      display none
      position absolute
      right -1px
      top 100%
      border 1px solid #dddee1
      border-top-color #fff
      background #fff
      padding 0.7rem 0.4rem 0.4rem 0.4rem
      box-shadow 0 .2rem 1rem -.1rem rgba(0, 0, 0, .25)
      border-radius 0 0 4px 4px
      button {
        margin .4rem
      }
    }

    &.is-edit {
      position absolute
      cursor default
      z-index 10
      background #fff
      border-color #dddee1
      box-shadow 0 .2rem 1rem -.1rem rgba(0, 0, 0, .25)
      &:before {
        content ''
        position absolute
        top 0
        left 0
        width 100%
        height 100%
        background #fff
        z-index 2
      }
      .grid-editor-footer {
        display inline-block
      }
    }

    //last
    &.is-last {
      .el-form-item__error{
        top -5px
        transform translateY(-100%)
      }
      .grid-editor-footer {
        top auto
        bottom 100%
        border-radius 4px 4px 0 0
        box-shadow 0 .2rem -1rem -.1rem rgba(0, 0, 0, .25)
        border-top-color #dddee1
        border-bottom-color #fff
        padding 0.4rem 0.4rem 0.7rem 0.4rem
      }
    }
  }
  &.ranked .grid-editor-wrapper {
    left 2rem
  }
</style>
